import { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import clock from '~/assets/icons/clock.svg';
import { Divider } from '~/components/ui/Divider';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { formatTime } from '~/shared/utils/time';
import {
	StyledContainer,
	StyledShadow,
	StyledTopContainer,
} from './JailInfo.styled';

const JailInfo = () => {
	const playerJailInfo = useObservable(rage.player.getPlayerJailInfo());
	const isVisible = playerJailInfo !== null;
	const timerRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (!playerJailInfo) {
			if (timerRef.current) {
				timerRef.current.textContent = '';
			}
			return;
		}

		if (playerJailInfo.expiresAt === null) {
			if (timerRef.current) {
				timerRef.current.textContent = 'Бессрочно';
			}
			return;
		}

		const update = () => {
			if (timerRef.current && playerJailInfo.expiresAt !== null) {
				const remaining = Math.max(0, playerJailInfo.expiresAt - Date.now());
				timerRef.current.textContent = formatTime(remaining, '{hh}:{mm}:{ss}');
			}
		};

		update();
		const interval = setInterval(update, 1000);
		return () => clearInterval(interval);
	}, [playerJailInfo]);

	return (
		<CSSTransition
			in={isVisible}
			classNames="jail-info"
			timeout={300}
			unmountOnExit
			appear
		>
			<StyledContainer>
				<StyledShadow />
				<StyledTopContainer>
					<Text style={{ fontSize: 16, color: '#FFFFFF', opacity: 0.5 }}>
						До конца срока
					</Text>
					{playerJailInfo?.expiresAt !== null && (
						<ImgIcon icon={clock} width={14} height={14} color="#FABE2C" />
					)}
					<Text
						ref={timerRef}
						style={{
							fontSize: 16,
							color: '#FABE2C',
							fontWeight: 700,
							textAlign: 'right',
						}}
					>
						00:00:00
					</Text>
				</StyledTopContainer>
				<Divider $direction="H" $color="#FFFFFF" style={{ opacity: 0.1 }} />
				<Text
					style={{
						fontSize: 16,
						color: '#FFFFFF',
						opacity: 0.5,
						fontWeight: 500,
						textAlign: 'center',
					}}
				>
					{playerJailInfo?.reason}
				</Text>
			</StyledContainer>
		</CSSTransition>
	);
};

export { JailInfo };
